import { all, fork } from 'redux-saga/effects';
import siteComponentSagas from 'yoda-site-components/lib/sagas';
import watchBreadCrumbNavRequest from 'yoda-site-components/lib/sagas/BreadCrumbNavSaga';
import {
    watchApplyAdjustmentsRequest,
    watchRemoveAdjustmentsRequest,
    watchgetAppliedAdjustmentsRequest,
    watchgetEmptyAdjustmentsRequest,
} from 'yoda-site-components/lib/sagas/AdjustmentSaga';

const siteComponentSagaList = Object.values(siteComponentSagas.injectedSagas);
const productSagas = [
    /**
     * IRIS component breadcrumbs
     * yoda-site-components/src/components/BreadCrumbNav/BreadCrumbNav.jsx
     */
    watchBreadCrumbNavRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchApplyAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchRemoveAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon get
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchgetAppliedAdjustmentsRequest,
    /**
     * coupon, cart, checkout, header/footer - coupon application
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/CouponDrawer/CouponDrawerAsync.jsx
     */
    watchgetEmptyAdjustmentsRequest,
    ...siteComponentSagaList,
];

const injectedSagas = {};
for (const saga of productSagas) { // eslint-disable-line
    // 1. Check that every saga has a name
    if (!saga.sagaName) {
        throw new Error(
            `Every saga has to have sagaName property. For debug purposes: ${saga.toString()}`
        );
    }

    // 2. Check that we have only unique sagas (one could be from components, another the same one from shared)
    if (injectedSagas[saga.sagaName]) {
        throw new Error(
            `That saga ${saga.sagaName} was already registered. Only 1 instance for particular name is allowed`
        );
    }
    injectedSagas[saga.sagaName] = saga;
}

const productRootSaga = function* productRootSaga() {
    yield all(Object.values(injectedSagas).map((saga) => fork(saga)));
};

productRootSaga.injectedSagas = injectedSagas;

export default productRootSaga;
